// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-payment_stripe-card',
    // #endregion
    // #region Properties
    props: {
        gateway: {
            type: Object,
            required: true,
            default: {}
        },
        method: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        paymentErrors: '',
        cardName: '',
        _gateway: {},
        _card: {},
    }),
    // #endregion
    // #region Mount
    beforeMount() {
        //Bus
        this.$appHost.eventBus.on('checkout-before-commit', this.CreatePaymentMethod);
        //Gateway
        this._gateway = this.$appHost.provider.get('PAYMENT', this.gateway.clientType);
        //Init
        this._gateway.initialize(this.gateway)
            .then(e => {
            this._gateway.createElement('card', this.method.element)
                .then(f => {
                //Set
                this._card = f;
                //Mount
                this._card.mount(this.$refs.card_element);
                //Errors
                this._card.addEventListener('change', this.onPaymentChange);
            });
        });
    },
    beforeUnmount() {
        this.$appHost.eventBus.off('checkout-before-commit', this.CreatePaymentMethod);
    },
    // #endregion
    // #region Core
    methods: {
        async CreatePaymentMethod(args) {
            // #region Check
            if (utils.isNullOrEmpty(this.cardName)) {
                this.paymentErrors = "Bitte geben Sie einen Karten-Inhaber ein.";
                args.cancel = true;
                return;
            }
            // #endregion
            // #region Core
            try {
                //Run
                let tResult = await this._gateway.api.createPaymentMethod({
                    type: 'card',
                    card: this._card,
                    billing_details: {
                        name: this.cardName
                    }
                });
                if (tResult.error) {
                    this.paymentErrors = tResult.error.message;
                    args.cancel = true;
                }
                else {
                    args.data.payment.details = {
                        paymentID: tResult.paymentMethod.id
                    };
                }
            }
            // #endregion
            // #region Error
            catch (error) {
                this.paymentErrors = error;
                args.cancel = true;
            }
            // #endregion
        },
        onPaymentChange(event) {
            if (event.error) {
                this.paymentErrors = event.error.message;
            }
            else {
                this.paymentErrors = '';
            }
        },
    },
    // #endregion
});
// #endregion
